import styled from 'styled-components'
import { Heading, theme } from '@notino/react-styleguide'

// styles
import { MY_RESERVATION_PAGE_MOBILE_BREAKPOINT } from '../../../../styles/constants'
import { NotinoLabelLarge, NotinoLabelRegular400, NotinoLabelRegular500, resetButtonStyles } from '../../../../styles/helpers'

export const PassDetailLayout = styled.div`
	display: grid;
	gap: 20px;
	grid-template-areas:
		'title'
		'qr'
		'summary';

	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		gap: 40px;
		grid-template-columns: minmax(0, 1fr) 420px;
		grid-template-areas:
			'title qr'
			'summary qr';
		align-items: start;
	}
`

export const PassDetailMain = styled.div`
	display: contents;
`

export const PassDetailTitle = styled(Heading.H1)`
	grid-area: title;
	font-weight: 500;
	margin: 0;
	text-align: left !important;
`

export const PassDetailSummary = styled.div`
	grid-area: summary;
	padding-top: 0;

	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		padding-top: 20px;
	}
`

export const PassDetailRow = styled.div`
	display: flex;
	gap: 10px;

	&:not(:last-child) {
		padding-bottom: 16px;
		margin-bottom: 16px;
		border-bottom: 1px solid ${theme.color.border.divider};
	}
`

export const PassDetailRowWithBadge = styled(PassDetailRow)`
	align-items: center;
	justify-content: space-between;
`

export const PassDetailLeftGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	min-width: 0;
`

export const PassDetailIcon = styled.div`
	flex-shrink: 0;

	svg {
		width: 1.25rem;
		height: 1.25rem;
		color: ${theme.color.icon.primary};
	}
`

export const PassDetailContent = styled.div`
	flex: 1;
	min-width: 0;
`

export const PassDetailRowHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 4px;
`

export const PassDetailLabel = styled.p`
	${NotinoLabelRegular400};
	margin: 0;
	color: ${theme.color.text.secondary};
`

export const PassDetailValue = styled.p`
	margin: 0;
	${NotinoLabelLarge};
	line-height: 1.5rem;
	word-break: break-word;
	color: ${theme.color.text.primary};
`

export const SeeDetailLink = styled.a`
	${NotinoLabelRegular400};
	flex-shrink: 0;
	color: ${theme.color.text.primary};
	text-decoration: underline;
`

export const PassQrCodeSidebar = styled.div`
	grid-area: qr;
	width: 100%;

	@media (min-width: ${MY_RESERVATION_PAGE_MOBILE_BREAKPOINT}) {
		width: 420px;
	}
`

export const PassQrCodeCard = styled.section`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 14px 20px 20px;
`

export const PassQrCodeImageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 159px;
	height: 159px;
	margin-bottom: 12px;
	background-color: ${theme.color.background.primary};
`

export const PassQrCodeImage = styled.img`
	display: block;
	width: 100%;
	height: 100%;
	object-fit: contain;
`

export const PassQrCodeValue = styled.p`
	${NotinoLabelRegular400};
	margin: 0;
	color: ${theme.color.text.primary};
	text-align: center;
	word-break: break-all;
`

export const PassQrCodeSkeleton = styled.div`
	width: 159px;
	height: 159px;
	border-radius: 4px;
	background-color: ${theme.color.background.tertiary};
`

export const PassQrCodeError = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;
	width: 100%;
	min-height: 159px;
	margin-bottom: 12px;
	padding: 40px 20px;
	box-sizing: border-box;
`

export const PassQrCodeErrorMessage = styled.p`
	${NotinoLabelRegular400};
	margin: 0;
	color: ${theme.color.text.secondary};
	text-align: center;
`

export const PassQrCodeReloadButton = styled.button`
	${resetButtonStyles};
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	padding: 4px;
`

export const PassQrCodeReloadLabel = styled.span`
	${NotinoLabelRegular500};
	color: ${theme.color.text.primary};
	text-decoration: underline;
`
